import { Component, inject, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ApiRequestsService, RESPONSE } from '../../services/api-requests.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { CommonFunctionService } from '../../services/common-function.service';
import { ToastrService } from 'ngx-toastr';
import { FormsObjectType, VioInputModule, VioInputService } from 'vio-input';
import { DisableWhileDirective } from "../../shared/directives/disable-while.directive";

const CHANGE_PWD_FORM = {
  // currentPassword: { dataType: 'string', inputType: 'password', groupName: '', rightActionIcon:'true', groupHeading: '', isRequired: true, isReadOnly: false, isHidden: false, placeHolder: 'Enter Current Password', label: 'Current Password', value: '', marginPading: 'mb-4', columnSize: 12, },
  newPassword: { dataType: 'string', inputType: 'password', groupName: '', groupHeading: '', isRequired: true, isReadOnly: false, isHidden: false, placeHolder: 'Enter New Password', label: 'New Password', value: '', marginPading: 'mb-4', columnSize: 12 },
  confirmNewPassword: { dataType: 'string', inputType: 'password', groupName: '', groupHeading: '', isRequired: true, isReadOnly: false, isHidden: false, placeHolder: 'Enter Confirm New Password', label: 'Confirm New Password', value: '', marginPading: 'mb-4', columnSize: 12 },
}

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbModule, VioInputModule, DisableWhileDirective],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
  providers: [NgbActiveModal],
})


export class ChangePasswordComponent implements OnInit {
  private router = inject(Router);
  @Input() data: any;
  changePassword: FormsObjectType = {
    config: {
      numberOfColumnsInRow: 1,
      formSubmitURL: '',
      isInvalidNoRequiredFieldSubmitted: false,
      showError: 'Inline',
      showLineBellowGroup: false,
      displayType: 'Floating',
    },
    fields: JSON.parse(JSON.stringify(CHANGE_PWD_FORM)),
  };

  isSubmitting: boolean = false;



  constructor(public common: CommonFunctionService, private ngbModal: NgbModal, private vioInputService: VioInputService, private apiRequest: ApiRequestsService, private toaster: ToastrService) { }
  ngOnInit(): void {
    this.common.pageTitle = 'Change Password';
  }

  saveChangePassword = async () => {
    this.isSubmitting = true;
    if (!this.vioInputService.validateFormObject(this.changePassword.fields)) {
      this.isSubmitting = false;
      return;
    }
    let password = this.changePassword.fields['newPassword'].value;
    let confirmPassword = this.changePassword.fields['confirmNewPassword'].value;
    if (password !== confirmPassword) {
      this.changePassword.fields['confirmNewPassword'].error = 'Confirm Password does not match with New password.';
      return;
    }
    let params = { password }
    let { errorCode, errorDescription, Data } = await this.apiRequest.postAPICallWithPromise('user/changePassword', params,)
    if (errorCode == this.apiRequest.NO_ERROR) {

      this.isSubmitting = false;
      this.toaster.success(`Password changed successfully`);
      setTimeout(() => {
        this.closeModal();
        if (this.data && this.data.from == 'profile') { }
        else {
          this.router.navigateByUrl('user-dashboard')
        }
      }, 2000)

    } else {

    }
    this.isSubmitting = false;
  }

  closeModal() {
    if (this.data && this.data?.from == 'profile') {
      this.ngbModal.dismissAll();
    } else {
      this.router.navigateByUrl('/user-dashboard');
    }

  }

}
